import { CoachType } from '../graphql/types';

/** Base URL used when parsing relative URL paths (e.g. from exos: scheme). */
const URL_PARSE_BASE = 'https://fit.teamexos.com';

/**
 * Returns Mixpanel event_category for chat tracking, aligned with heart-mobile.
 * Used for event_category on chat User Action and Screen View events.
 */
export function getChatTrackingEventCategory(
  coachType: CoachType | null | undefined,
): string {
  if (coachType === CoachType.Dietitian) {
    return 'nutrition';
  }
  return 'coach';
}

/** True if URL is an on-demand or video content link (for video_play tracking). */
export function isVideoContentUrl(url: string): boolean {
  const u = url?.trim() ?? '';
  if (!u) {
    return false;
  }
  try {
    const path = new URL(u, URL_PARSE_BASE).pathname.replace(/^\/+/, '');
    return (
      /^ondemand\/[^/]+/.test(path) ||
      /^video\/full\/[^/]+\/[^/]+/.test(path) ||
      /^classes\/ondemand\/[^/]+/.test(path)
    );
  } catch {
    return false;
  }
}

/** Extracts content ID from on-demand/video URL for video_play content_id, or undefined. */
export function getVideoContentIdFromUrl(url: string): string | undefined {
  const u = url?.trim() ?? '';
  if (!u) {
    return undefined;
  }
  try {
    const path = new URL(u, URL_PARSE_BASE).pathname.replace(/^\/+/, '');
    const ondemandMatch = path.match(
      /(?:^ondemand\/|^classes\/ondemand\/)([^/?]+)/,
    );
    if (ondemandMatch) {
      return ondemandMatch[1];
    }
    const videoMatch = path.match(/^video\/full\/[^/]+\/([^/?]+)/);
    if (videoMatch) {
      return videoMatch[1];
    }
    return undefined;
  } catch {
    return undefined;
  }
}
